import React, { useState, useEffect } from 'react';
import roseBed from '../../img/rose_bed_lay.png'
import lilyScreenshot from '../../img/lilyscreenshot.png'
import erikahjpreview from '../../img/hjpreview.png'

export default function DevlogPage() {
  // --- RESPONSIVE STATE ---
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // --- STYLES ---
  const styles = {
    container: {
      backgroundColor: 'transparent', 
      minHeight: '100vh',
      padding: isMobile ? '40px 15px' : '80px 20px', // Mobile padding
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      fontFamily: '"Inter", sans-serif',
      color: '#f8fafc', 
    },
    header: {
      textAlign: 'center',
      marginBottom: '60px',
    },
    title: {
      fontSize: isMobile ? '2.5rem' : '3rem', // Scaled for mobile
      fontWeight: '900',
      marginBottom: '10px',
      color: '#ffffff', 
      letterSpacing: '-1px',
    },
    subtitle: {
      fontSize: '1.2rem',
      color: '#94a3b8', 
    },
    feed: {
      width: '100%',
      maxWidth: '800px',
      display: 'flex',
      flexDirection: 'column',
      gap: '40px',
    },
    postCard: {
      backgroundColor: '#111c3a', 
      borderRadius: '16px',
      padding: '0', 
      boxShadow: '0 10px 30px rgba(0,0,0,0.4)', 
      overflow: 'hidden',
      border: '1px solid #1c2b4d', 
      transition: 'transform 0.2s',
    },
    postImage: {
      width: '100%',
      height: isMobile ? '200px' : '300px', // Shorter hero image on mobile
      objectFit: 'cover',
      backgroundColor: '#162447', 
      borderBottom: '1px solid #1c2b4d',
    },
    postContent: {
      padding: isMobile ? '20px' : '40px', // Tighter padding on mobile
    },
    postMeta: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
      fontSize: '0.9rem',
      color: '#64748b', 
      textTransform: 'uppercase',
      letterSpacing: '1px',
      fontWeight: 'bold',
    },
    tag: {
      backgroundColor: 'rgba(176, 38, 255, 0.1)', 
      color: '#b026ff', 
      padding: '5px 12px',
      borderRadius: '20px',
      fontSize: '0.8rem',
      border: '1px solid rgba(176, 38, 255, 0.3)', 
    },
    postTitle: {
      fontSize: isMobile ? '1.5rem' : '2rem', // Scaled for mobile
      fontWeight: 'bold',
      marginBottom: '20px',
      lineHeight: '1.3',
      color: '#f8fafc', 
    },
    postText: {
      fontSize: '1.1rem',
      lineHeight: '1.8',
      color: '#cbd5e1', 
      marginBottom: '20px',
    },
    codeBlock: {
      backgroundColor: '#050a18', 
      color: '#38bdf8', 
      padding: '20px',
      borderRadius: '8px',
      fontFamily: 'monospace',
      fontSize: '0.9rem',
      marginBottom: '20px',
      overflowX: 'auto',
      border: '1px solid #1c2b4d',
    },
    // NEW: The universal style for images inside blog posts!
    inlineImage: {
      maxWidth: '100%', // Never let it break out of the container
      height: 'auto', // Keep proportions correct
      borderRadius: '8px', // Match the code blocks
      display: 'block', // Ensures it acts as a block element
      margin: '30px auto', // Centers the image and gives it vertical breathing room
      border: '1px solid #1c2b4d',
      boxShadow: '0 8px 25px rgba(0,0,0,0.3)',
    }
  };

  // MOVED INSIDE THE COMPONENT: So it can access styles.inlineImage
  const blogPosts = [
    {
      id: 7,
      date: "March 16, 2026",
      tag: "Art/Animation",
      title: "Erika's First Reward Video",
      image: null,
      content: (
        <>
          <p>
            Part of the game loop will be earning money to pay rent on a weekly basis, hitting quota for the studio, etc... however, what
            can you do with the leftover money? That's where LonelyHands comes in! While you're typically on the other end of the platform,
            you're able to access the LonelyHands client-view and buy yourself some stress relief as well. This is WIP of one of Erika's "reward"
            videos that can be bought with your excess cash. 
          </p>
          <img src={erikahjpreview} style={styles.inlineImage} alt='Erika HJ Preview' />
          <p>
            You can view the full, animated, and uncensored WIP over on our <a href="https://x.com/ForeplayGames/status/2033626681882341399" target="_blank">Twitter/X Page!</a>
          </p>
        </>
      )
    },
    {
      id: 6,
      date: "March 12, 2026",
      tag: "Recruiting",
      title: "Wrapping Up Scripts + Casting Call",
      image: null,
      content: (
        <>
          <p>
            As we're wrapping up all of the scripts for all of our characters in LonelyHands, and with much deliberation from the team,
            we've decided to hire voice actors for LonelyHands. Originally, we were going to keep the game as low budget as we could,
            which meant doing away with things such as voice acting as a possibilty. However, as we completed the project's scripts,
            we couldn't help but feel that we really needed something to bring home the experience. We decided to pull the trigger and
            got a casting call going for our project.
          </p>
          <p>
            You can find the casting call itself over at <a target="_blank" href='https://www.castingcall.club/projects/lonelyhands'>Casting Call Club</a>
            if you are interested in auditioning! We've been open for about a week now and have a little over a week left to go as of time of writing. 
          </p>
          <p>
            This decision doesn't come without some work though, finding the actors aside, we have to adapt our completely text-based scripts
            to work a bit better with voice acting on top of it. It also means we're adding more varied volume control, instead of having a single
            master volume toggle (though we do still have that) we are going to be splitting it between sound effects, voice acting, and background music.
          </p>
          <p>
            All in all, more work all around but we're excited to see the project come to life even more. Stay tuned for more news on our games' production!
          </p>
        </>
      )
    },
    {
      id: 5,
      date: "March 2, 2026",
      tag: "New Project",
      title: "Teasing Our Next Sandbox: LonelyHands",
      image: null, 
      content: (
        <>
          <p>
            While <em>3XRay</em> is our flagship focus, we have another small game that we're close to completing.
            And we're happy to say that we are using a real artist and not AI Generated art for it. 
            The title <b>LonelyHands</b> should sound an awful lot like a particular platform only for fans.
          </p>
          
          {/* APPLIED THE INLINE STYLE HERE */}
          <img src={lilyScreenshot} style={styles.inlineImage} alt='LonelyHands Screenshot' />
          
          <p>
            It’s a work-simulation game where you play as a struggling college student desperate to pay tuition. 
            Your solution? Getting hired as a "ghostwriter" to manage the direct messages for top models on a 
            massive, subscription-based adult platform. 
          </p>
          <p>
            While the bulk of the game plays out on a simulated computer desktop UI, forcing you to juggle clickable apps, 
            an email client, and the main chatter app to progress the story, you aren't glued to the desk. 
            You can step away from the screen to interact with your roommate in your apartment or head out for 
            the office, parks, etc... balancing your digital hustle with your physical reality.
          </p>
          <p>
            We know it might seem ironic for an adult game studio to critique the adult content industry. 
            But to us, the distinction is massive. There is a world of difference between a player paying a flat 
            indie price for a crafted, fictional narrative experience, and a platform using predatory, parasocial 
            tactics to squeeze endless funds out of financially vulnerable people.
          </p>
          <p>
            <em>LonelyHands</em> explores that dark grey area. When your survival is on the line, how far will you 
            go to manipulate a stranger on the other side of the screen?
          </p>
        </>
      )
    },
    {
      id: 3,
      date: "February 14, 2026",
      tag: "Tech Art",
      title: "Implementing the X-Ray Cursor",
      image: null, 
      content: (
        <>
          <p>
            One of the core mechanics of 3XRay is the ability to see through the facade (literally). 
            We didn't want a simple "Toggle Switch" UI; we wanted it to feel tactile.
          </p>
          <p>
            On <a href="/games/3xr" style={{color: '#b026ff', fontWeight: 'bold', textDecoration: 'none'}}>3XRay's page</a>, we implemented a CSS masking system that tracks the mouse position in real-time. 
            It stacks two images, the "Public" layer and the "Secret" layer, and cuts a hole in the top one.
          </p>
          <div style={styles.codeBlock}>
            mask-image: radial-gradient(circle 150px at cursorX cursorY, transparent, black);
          </div>
          <p>
            It's not new technology, but it was fun and surprisingly easy to build, and really gives the page a nice interactive and
            interesting 'pop'. Go check it out!
          </p>
        </>
      )
    },
    {
      id: 2,
      date: "February 6, 2026",
      tag: "Announcement",
      title: "Project Reveal: 3XRay",
      image: null, 
      content: (
        <>
          <p>
            It is time to officially pull the curtain back on our first large scale title: <b>3XRay</b>.
          </p>
          <p>
            Set in the prestigious (and deeply corrupt) St. Aethelgard University, the game kicks off 
            when you suffer a humiliating public defeat at the hands of a delinquent student named Anna. But that night,
            your luck changes. A succubus named Akala visits you with a devilish offer, granting you the power of X-Ray
            vision to beat Anna at her own game, and uncover so much more.
          </p>
          <p>
            We are using Spine for animation on the more 'spicy' parts of the game to give our character 
            animations a smooth, breathing life that static images just can't capture. With over 20 heroines 
            planned, the core of the game is about moral choices. Will you use your newfound vision to uncover 
            conspiracies and help your classmates, or will you use their darkest secrets against them?
          </p>
          
          {/* APPLIED THE INLINE STYLE HERE */}
          <img src={roseBed} style={styles.inlineImage} alt='Rose Bed Scene'/>
          
          <p>
            Stay tuned. We have a lot of mechanics to show off in the coming weeks.
          </p>
        </>
      )
    },
    {
      id: 1,
      date: "January 30, 2026",
      tag: "Studio",
      title: "Welcome to Foreplay Games",
      image: null,
      content: (
        <>
          <p>
            Hello world! We are officially launching our site and our studio. 
            Our goal is simple: create adult games with meaning and narrative depth. A slow burn as opposed to 'quick and dirty'.
          </p>
          <p>
            We want to make more than just linear "click to advance" visual novels with zero interaction.
            We are hoping to build systems, mechanics, and worlds with more meaning and purpose, rather than a 'quick fap'. 
            A 'slow burn' is the best way to describe how we want our games to play, and while that might not be
            everyone's cup of tea, we believe that 'foreplay' (or rather, the game's progression towards the eventual sex scene, 
            hence our studio's name) is important, and having that be part of the experience, the buildup, makes the payoff so much
            more satisfying, assuming it is built well. That's what we will be striving for.
          </p>
        </>
      )
    }
  ];

  return (
    <div style={styles.container}>
      
      <div style={styles.header}>
        <h1 style={styles.title}>Developer Log</h1>
        <p style={styles.subtitle}>Updates, sketches, and technical deep-dives.</p>
      </div>

      <div style={styles.feed}>
        {blogPosts.map((post) => (
          <div key={post.id} style={styles.postCard}>
            
            {post.image && (
              <img src={post.image} style={styles.postImage} alt={post.title} />
            )}

            <div style={styles.postContent}>
              <div style={styles.postMeta}>
                <span>{post.date}</span>
                <span style={styles.tag}>{post.tag}</span>
              </div>
              
              <h2 style={styles.postTitle}>{post.title}</h2>
              
              <div style={styles.postText}>
                {post.content}
              </div>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
}